/** Non-iOS stub. Real implementation lives in iosVoipPush.ios.ts. */

export type VoipPushSetupTeardown = () => void;

export async function setupIosVoipPush(): Promise<VoipPushSetupTeardown> {
  return () => {};
}
